import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';

const domNode = document.getElementById('root')!; // ! avoid the error Argument of type 'HTMLElement | null' is not assignable to parameter of type 'Container'.
const root = createRoot(domNode);
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);
